
import { createContext } from 'react';

export const SettingsSearchContext = createContext<string>('');
